export default 'Date picker: ';